var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"ma-auto",attrs:{"contain":"","height":"22vh","max-width":"150","width":"75%","src":require("@/assets/custom/images/login-logo.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }